import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.genres),function(genre){return _c(VChip,{key:genre,staticClass:"mr-1",attrs:{"small":"","dark":"","pill":"","label":"","color":_vm.get_color(genre)}},[_vm._v(" "+_vm._s(genre)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }